import { useLocation, Outlet } from "react-router-dom";
import { useAuth } from "../auth/AuthProvider";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { modalActions } from "@/stores/modal-store"; 

function FullscreenSpinner() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50">
      <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-brand-600"></div>
    </div>
  );
}

const PUBLIC_ROUTES = ["/membership", "/forgot"];

export default function ProtectedRoute() {
  const { user, loading } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  const isPublicRoute = PUBLIC_ROUTES.some((route) =>
    location.pathname.startsWith(route),
  );

  useEffect(() => {
    if (!loading && !user && !isPublicRoute) {
      const returnTo = location.pathname + location.search;

      modalActions.open("signin", { returnTo });

      navigate("/", {
        replace: true,
        state: { from: location },
      });
    }
  }, [user, loading, location, navigate, isPublicRoute]);

  if (loading) {
    return <FullscreenSpinner />;
  }

  if (!user && !isPublicRoute) {
    return <div className="min-h-screen bg-slate-50"></div>;
  }

  return <Outlet />;
}
